module.exports = __webpack_public_path__ + "media/images/icons/close-19503dc5315eade55563f9b03b3ab04a.svg";